/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WifiStatusChangePayload
 */
export interface WifiStatusChangePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: WifiStatusChangePayloadTypeEnum;
    /**
     * 
     */
    connected: boolean;
    /**
     * 
     */
    ssid?: string | null;
    /**
     * 
     */
    ipv4?: string | null;
    /**
     * 
     */
    signalPct?: number | null;
    /**
     * 
     */
    previousSsid?: string | null;
}


/**
 * @export
 */
export const WifiStatusChangePayloadTypeEnum = {
    WifiStatusChange: 'wifi_status_change',
} as const;
export type WifiStatusChangePayloadTypeEnum = typeof WifiStatusChangePayloadTypeEnum[keyof typeof WifiStatusChangePayloadTypeEnum];


/**
 * Check if a given object implements the WifiStatusChangePayload interface.
 */
export function instanceOfWifiStatusChangePayload(value: object): value is WifiStatusChangePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'wifi_status_change') return false;
    
    if (!('connected' in value) || value['connected'] === undefined) return false;
    return true;
}

export function WifiStatusChangePayloadFromJSON(json: any): WifiStatusChangePayload {
    return WifiStatusChangePayloadFromJSONTyped(json, false);
}

export function WifiStatusChangePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): WifiStatusChangePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'connected': json['connected'],
        'ssid': json['ssid'] === undefined ? undefined : json['ssid'] === null ? null : json['ssid'],
        'ipv4': json['ipv4'] === undefined ? undefined : json['ipv4'] === null ? null : json['ipv4'],
        'signalPct': json['signal_pct'] === undefined ? undefined : json['signal_pct'] === null ? null : json['signal_pct'],
        'previousSsid': json['previous_ssid'] === undefined ? undefined : json['previous_ssid'] === null ? null : json['previous_ssid'],
    };
}

export function WifiStatusChangePayloadToJSON(json: any): WifiStatusChangePayload {
    return WifiStatusChangePayloadToJSONTyped(json, false);
}

export function WifiStatusChangePayloadToJSONTyped(value?: WifiStatusChangePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'connected': value['connected'],
        'ssid': value['ssid'],
        'ipv4': value['ipv4'],
        'signal_pct': value['signalPct'],
        'previous_ssid': value['previousSsid'],
    };
}

